/**
 * Application Configuration
 * Static configuration imported at build time
 */

export const appConfig = {
  app_name: "OrderingPlus Admin",
  app_internal_name: "finitless-dashboard",
  notification_app: "dashboardweb",
  project: "orderingplus",
  billing_url: "https://accounts.ordering.co",
  billing_api_url:
    import.meta.env.VITE_BILLING_API_URL || "https://api-billing.ordering.co",
  stripe_public_key: "pk_live_RAOVLcGuYx9v8qlk50gdsQD1",
  posthog_api_key: import.meta.env.VITE_POSTHOG_API_KEY || "",
  api: {
    url: import.meta.env.VITE_API_URL || "https://api.core.finitless.com",
    language: "en",
    version: "v400",
  },
  configurations: {
    subdomain: "orderingplus",
  },
  socket: {
    url: "https://sockets-v3.orderingplus.com",
  },
  pro_plan_id: [401],
  use_project_domain: false,
  use_project_subdomain: false,
  google_tag_manager: "GTM-N9QWTN5J",
  use_batch_sockets: false,
  use_franchise_images: false,
  is_white_label: false,
};

export default appConfig;
